export interface SubscriptionBarProps {
  className?: string;
}

export enum SubscriptionExpirationStatus {
  active,
  expired,
  expiring,
}
